import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../assets/css/Tour.css";

// Images
import heroImg from "../assets/images/b2.webp";
import tirthsarthiBanner from "../assets/images/heros1.webp"; // Add your tirthsarthi banner image
import gypsyClubBanner from "../assets/images/tour/gypsy.jpeg"; // Add your gypsy club banner image
import gypsyWildlifeBanner from "../assets/images/wild.webp"; // Add your gypsy wildlife banner image
import allToursBanner from "../assets/images/tour/alltours.jpeg"; // Add your all tours banner image

// Tour Images
import img1 from "../assets/images/heros3.webp";
import img2 from "../assets/images/tulip.jpg";
import img3 from "../assets/images/Summercamp.jpg";
import img4 from "../assets/images/heros1.webp";
import img5 from "../assets/images/kanherimathkolhapur.jpg";
import img6 from "../assets/images/Kailas.jpg"
import img7 from "../assets/images/ValleyofFlowersTrekwithGypsyClub.jpeg";
import img8 from "../assets/images/PinBhabaPassTrekOrganizedbyGypsyClub.jpeg"

function Tour() {
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [categoryName, setCategoryName] = useState("All Tours");
  const [currentBanner, setCurrentBanner] = useState(heroImg);

  const tours = [
    {
      id: 1,
      img: img1,
      title: "वाईल्डलाईफ अ‍ॅडव्हेंचर - ताडोबा",
      date: "May 16-18, 2026",
      author: "Gypsy Wildlife",
      desc: "३ दिवस / २ रात्र | ४ जिप सफारी | वाघांचे दर्शन",
      price: "₹20,000",
      duration: "3 Days",
      location: "Tadoba",
      category: "gypsy-wildlife",
    },
    {
      id: 2,
      img: img2,
      title: "ट्युलिप स्पेशल काश्मीर टूर",
      date: "April 8-12, 2026",
      author: "Gypsy Club",
      desc: "५ दिवस / ४ रात्री | ट्युलिप गार्डन | शिकारा",
      price: "₹20,500",
      duration: "5 Days",
      location: "Kashmir",
      category: "gypsy-club",
    },
    {
      id: 3,
      img: img3,
      title: "मोगली समर कॅम्प",
      date: "April 24-26, 2026",
      author: "Gypsy Club",
      desc: "३ दिवस | जंगल ट्रेकिंग | कॅम्प फायर",
      price: "₹8,000",
      duration: "3 Days",
      location: "Bhor",
      category: "gypsy-club",
    },
    {
      id: 4,
      img: img4,
      title: "चार धाम यात्रा",
      date: "June 11-20, 2026",
      author: "तीर्थसारथी",
      desc: "१० दिवस | केदारनाथ | बद्रीनाथ",
      price: "₹46,000",
      duration: "10 Days",
      location: "Uttarakhand",
      category: "tirthsarthi",
    },
    {
      id: 5,
      img: img5,
      title: "सिद्धगिरी महोत्सव",
      date: "April 4, 2026",
      author: "तीर्थसारथी",
      desc: "१ दिवस | हस्तकला | संग्रहालय",
      price: "₹1,500",
      duration: "1 Day",
      location: "Kolhapur",
      category: "tirthsarthi",
    },
    {
      id: 6,
      img: img6,
      title: "कैलास मानसरोवर यात्रा",
      date: "September 22 - October 4, 2026",
      author: "तीर्थसारथी",
      desc: "१४ दिवस | काठमांडू दर्शन | कैलास | परिक्रमा | मानसरोवर तट",
      price: "₹2,10,000",
      duration: "14 Days",
      location: "Kathmandu",
      category: "tirthsarthi",
    },

    {
      id: 7,
      img: img7,
      title: "Valley of Flowers Trek",
      date: "August 3-8, 2026",
      author: "Gypsy Club",
      desc: "६ दिवस / ५ रात्री | Valley of Flowers | Hemkund Sahib | Himalayan Trek",
      price: "₹16,000",
      duration: "6 Days",
      location: "Uttarakhand",
      category: "gypsy-club",
    },
    {
      id: 8,
      img: img8,
      title: "Pin Bhaba Pass Trek",
      date: "July 17-23, 2026",
      author: "Gypsy Club",
      desc: "७ दिवस | Bhaba Valley | Pin Valley | Himalayan Crossover Trek",
      price: "₹22,500",
      duration: "7 Days",
      location: "Shimla to Spiti",
      category: "gypsy-club",
    },

  ];

  // Function to get banner based on category
  const getBannerImage = (category) => {
    switch (category) {
      case "tirthsarthi":
        return tirthsarthiBanner;
      case "gypsy-club":
        return gypsyClubBanner;
      case "gypsy-wildlife":
        return gypsyWildlifeBanner;
      default:
        return allToursBanner;
    }
  };

  // Category from URL
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const category = params.get("category");

    if (category) {
      setSelectedCategory(category);
      // Set proper category name for display
      if (category === "tirthsarthi") {
        setCategoryName("तीर्थसारथी");
        setCurrentBanner(tirthsarthiBanner);
      } else if (category === "gypsy-club") {
        setCategoryName("Gypsy Club");
        setCurrentBanner(gypsyClubBanner);
      } else if (category === "gypsy-wildlife") {
        setCategoryName("Gypsy Wildlife");
        setCurrentBanner(gypsyWildlifeBanner);
      } else {
        setCategoryName(category);
        setCurrentBanner(getBannerImage(category));
      }
    } else {
      setSelectedCategory(null);
      setCategoryName("All Tours");
      setCurrentBanner(allToursBanner);
    }
  }, [location]);

  const filteredTours = selectedCategory
    ? tours.filter((t) => t.category === selectedCategory)
    : tours;

  return (
    <>
      <Navbar />

      <div
        className="hero-responsive tour-banner"
        style={{
          backgroundImage: `url(${currentBanner})`,
        }}
      >
        <div className="banner-overlay"></div>

        <div className="container text-center banner-content">
          <div className="row justify-content-center">
            <div className="col-lg-8 col-md-10 col-12">
              <h1 className="banner-title animate-fade-up">
                {categoryName}
              </h1>

              <p className="banner-subtitle animate-fade-up-delay">
                {selectedCategory === "tirthsarthi" && "आध्यात्मिक यात्रा | Spiritual Journey"}
                {selectedCategory === "gypsy-club" && "एडवेंचर क्लब | Adventure Club"}
                {selectedCategory === "gypsy-wildlife" && "वन्यजीव सफारी | Wildlife Safari"}
                {!selectedCategory && "Discover Amazing Tours & Adventures"}
              </p>
            </div>
          </div>
        </div>
      </div>


      {/* Hero */}
      {/* <div className="ftco-blocks-cover-1">
        <div
          className="site-section-cover overlay"
          style={{
            backgroundImage: `url(${heroImg})`,
            height: "45vh",
            minHeight: "160px",
          }}
        >
          <div className="container">
            <div className="row align-items-center justify-content-center text-center">
              <div className="col-md-5">
                <h1 className="mb-2 text-white">Get In Touch</h1>
                <p className="text-white">Your journey begins with a message.</p>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* Modern Filter Buttons */}
      <div className="filter-container">
        <div className="filter-buttons-wrapper">
          <button
            onClick={() => navigate("/tour")}
            className={`filter-btn btn-all ${!selectedCategory ? "active" : ""}`}
          >
            <span className="btn-icon">🏠</span>
            <span className="btn-text">All Tours</span>
          </button>

          <button
            onClick={() => navigate("/tour?category=tirthsarthi")}
            className={`filter-btn btn-tirth ${selectedCategory === "tirthsarthi" ? "active" : ""}`}
          >
            <span className="btn-icon">🛕</span>
            <span className="btn-text">तीर्थसारथी</span>
          </button>

          <button
            onClick={() => navigate("/tour?category=gypsy-club")}
            className={`filter-btn btn-club ${selectedCategory === "gypsy-club" ? "active" : ""}`}
          >
            <span className="btn-icon">🎯</span>
            <span className="btn-text">Gypsy Club</span>
          </button>

          <button
            onClick={() => navigate("/tour?category=gypsy-wildlife")}
            className={`filter-btn btn-wildlife ${selectedCategory === "gypsy-wildlife" ? "active" : ""}`}
          >
            <span className="btn-icon">🦁</span>
            <span className="btn-text">Gypsy Wildlife</span>
          </button>
        </div>
      </div>

      {/* Cards */}
      <div className="container my-5">
        <div className="row">
          {filteredTours.length > 0 ? (
            filteredTours.map((tour) => (
              <div className="col-12 col-sm-6 col-md-6 col-lg-4 mb-4" key={tour.id}>
                <div className="tour-card">
                  {/* Image */}
                  <div className="tour-img-wrapper">
                    <img src={tour.img} className="tour-img" alt={tour.title} />
                    <div className="tour-overlay">
                      <span className="tour-price">{tour.price}</span>
                    </div>
                    <div className={`category-badge badge-${tour.category}`}>
                      {tour.category === "tirthsarthi" && "🛕 तीर्थसारथी"}
                      {tour.category === "gypsy-club" && "🎯 Gypsy Club"}
                      {tour.category === "gypsy-wildlife" && "🦁 Gypsy Wildlife"}
                    </div>
                  </div>

                  {/* Content */}
                  <div className="tour-content">
                    <h5 className="tour-title">{tour.title}</h5>
                    <div className="tour-meta">
                      {tour.date} • {tour.author}
                    </div>
                    <p className="tour-desc">{tour.desc}</p>
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="badge-duration">
                        ⏱️ {tour.duration}
                      </span>
                      <Link
                        to={`/tourdetails/${tour.id}`}
                        className="btn-view"
                      >
                        View Details →
                      </Link>
                    </div>
                    <div className="mt-2 location-badge">
                      📍 {tour.location}
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="col-12 text-center py-5">
              <div className="no-tours-message">
                <span className="no-tours-icon">🔍</span>
                <h3>No tours found in this category</h3>
                <p>Check back later for exciting new adventures!</p>
              </div>
            </div>
          )}
        </div>
      </div>

      <Footer />

      {/* CSS Styles */}
      <style>{`
        /* Hero Overlay */
        .hero-overlay {
          background: linear-gradient(135deg, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0.4) 100%);
          padding: 2rem;
          border-radius: 20px;
          text-align: center;
          backdrop-filter: blur(2px);
          animation: fadeInUp 0.8s ease;
        }

        .hero-overlay h1 {
          margin: 0;
          font-size: 3rem;
          text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
        }

        .hero-overlay p {
          font-size: 1.2rem;
          opacity: 0.95;
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-title {
          animation: fadeInUp 0.8s ease 0.2s both;
        }

        .animate-subtitle {
          animation: fadeInUp 0.8s ease 0.4s both;
        }

        /* Filter Container */
        .filter-container {
          padding: 2rem 1rem;
          background: linear-gradient(to bottom, #f8f9fa, #ffffff);
          position: sticky;
          top: 0;
          z-index: 100;
          box-shadow: 0 2px 20px rgba(0,0,0,0.05);
        }

        .filter-buttons-wrapper {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 1.2rem;
          max-width: 1200px;
          margin: 0 auto;
        }

        /* Base Button Styles */
        .filter-btn {
          position: relative;
          padding: 12px 28px;
          border: none;
          border-radius: 50px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          overflow: hidden;
          display: flex;
          align-items: center;
          gap: 10px;
          color: white;
          box-shadow: 0 2px 8px rgba(0,0,0,0.1);
        }

        .btn-icon {
          font-size: 1.2rem;
          transition: transform 0.3s ease;
        }

        .btn-text {
          position: relative;
          z-index: 1;
        }

        /* Ripple Effect */
        .filter-btn::before {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          width: 0;
          height: 0;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.5);
          transform: translate(-50%, -50%);
          transition: width 0.6s, height 0.6s;
        }

        .filter-btn:hover::before {
          width: 300px;
          height: 300px;
        }

        .filter-btn:hover {
          transform: translateY(-3px);
          box-shadow: 0 8px 20px rgba(0,0,0,0.15);
        }

        .filter-btn:hover .btn-icon {
          transform: scale(1.1);
        }

        .filter-btn:active {
          transform: translateY(0);
        }

        /* Active Button State */
        .filter-btn.active {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(0,0,0,0.2);
          position: relative;
        }

        .filter-btn.active::after {
          content: '';
          position: absolute;
          bottom: -2px;
          left: 50%;
          transform: translateX(-50%);
          width: 60%;
          height: 3px;
          background: currentColor;
          border-radius: 3px;
        }

        /* Individual Button Colors */
        .btn-all {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        }

        .btn-tirth {
          background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
        }

        .btn-club {
          background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
        }

        .btn-wildlife {
          background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
        }

        /* Hover Effects */
        .btn-all:hover {
          background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
          box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);
        }

        .btn-tirth:hover {
          background: linear-gradient(135deg, #f5576c 0%, #f093fb 100%);
          box-shadow: 0 8px 20px rgba(245, 87, 108, 0.4);
        }

        .btn-club:hover {
          background: linear-gradient(135deg, #00f2fe 0%, #4facfe 100%);
          box-shadow: 0 8px 20px rgba(79, 172, 254, 0.4);
        }

        .btn-wildlife:hover {
          background: linear-gradient(135deg, #38f9d7 0%, #43e97b 100%);
          box-shadow: 0 8px 20px rgba(67, 233, 123, 0.4);
        }

        /* Card Styles */
        .tour-card {
          border-radius: 15px;
          overflow: hidden;
          background: #fff;
          box-shadow: 0 5px 20px rgba(0,0,0,0.08);
          transition: 0.3s;
          height: 100%;
        }

        .tour-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 15px 35px rgba(0,0,0,0.15);
        }

        .tour-img-wrapper {
          position: relative;
          overflow: hidden;
        }

        .tour-img {
          width: 100%;
          height: 220px;
          object-fit: cover;
          transition: 0.4s;
        }

        .tour-card:hover .tour-img {
          transform: scale(1.1);
        }

        .tour-overlay {
          position: absolute;
          bottom: 0;
          width: 100%;
          background: linear-gradient(to top, rgba(0,0,0,0.7), transparent);
          padding: 10px;
          display: flex;
          justify-content: flex-end;
        }

        .tour-price {
          background: #a2f44a;
          color: #fff;
          padding: 5px 12px;
          border-radius: 20px;
          font-size: 14px;
          font-weight: 600;
        }

        .category-badge {
          position: absolute;
          top: 15px;
          left: 15px;
          padding: 5px 12px;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 600;
          color: white;
          backdrop-filter: blur(5px);
        }

        .badge-tirthsarthi {
          background: linear-gradient(135deg, #f093fb, #f5576c);
        }

        .badge-gypsy-club {
          background: linear-gradient(135deg, #4facfe, #00f2fe);
        }

        .badge-gypsy-wildlife {
          background: linear-gradient(135deg, #43e97b, #38f9d7);
        }

        .tour-content {
          padding: 15px;
        }

        .tour-title {
          font-weight: 600;
          font-size: 16px;
          margin-bottom: 8px;
          color: #333;
        }

        .tour-meta {
          font-size: 13px;
          color: #777;
          margin-bottom: 10px;
        }

        .tour-desc {
          font-size: 14px;
          color: #555;
          margin-bottom: 12px;
          line-height: 1.4;
        }

        .badge-duration {
          background: #f0f0f0;
          color: #666;
          padding: 4px 10px;
          border-radius: 15px;
          font-size: 12px;
        }

        .btn-view {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          padding: 5px 15px;
          border-radius: 20px;
          text-decoration: none;
          font-size: 13px;
          font-weight: 500;
          transition: all 0.3s ease;
          display: inline-block;
        }

        .btn-view:hover {
          transform: translateX(5px);
          color: white;
          text-decoration: none;
          box-shadow: 0 2px 8px rgba(102, 126, 234, 0.4);
        }

        .location-badge {
          font-size: 12px;
          color: #888;
        }

        /* No Tours Message */
        .no-tours-message {
          text-align: center;
          padding: 60px 20px;
          background: #f8f9fa;
          border-radius: 20px;
        }

        .no-tours-icon {
          font-size: 4rem;
          display: block;
          margin-bottom: 1rem;
        }

        /* Animation for active button */
        @keyframes pulse {
          0% {
            box-shadow: 0 0 0 0 rgba(255,255,255,0.4);
          }
          70% {
            box-shadow: 0 0 0 10px rgba(255,255,255,0);
          }
          100% {
            box-shadow: 0 0 0 0 rgba(255,255,255,0);
          }
        }

        .filter-btn.active {
          animation: pulse 0.5s ease-out;
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .hero-overlay h1 {
            font-size: 2rem;
          }

          .hero-overlay p {
            font-size: 1rem;
          }
          
          .filter-buttons-wrapper {
            gap: 0.8rem;
            padding: 0 1rem;
          }

          .filter-btn {
            padding: 8px 20px;
            font-size: 14px;
          }

          .btn-icon {
            font-size: 1rem;
          }

          .tour-title {
            font-size: 14px;
          }
        }

        @media (max-width: 480px) {
          .filter-btn {
            padding: 6px 16px;
            font-size: 12px;
            gap: 6px;
          }

          .btn-icon {
            font-size: 0.9rem;
          }

          .hero-overlay {
            padding: 1rem;
          }
        }
      `}</style>
    </>
  );
}

export default Tour;